import React from 'react';
import { MenuItem } from '@mui/material';
import IndividualTab from './IndividualTab';
import { IndTabs } from '../../redux/TabTile/TabStateInterfaces';

interface TabListProps {
  tabList: number[];
  tabState: any;
  tabTileProps: any;
  selectedTab?: number;
  backgroundColor?: string;
  handleClose?: () => void;
  toggleTabHidden: (tabId: number) => void;
  handleDeleteRequest?: (tabName: string, tabId: number) => void;
  handleSelectTab: (tabName: string, tabId: number) => void;
  handleRemoveTab: (tabName: string, tabId: number) => void;
  handleRenameTabBegin: (tabId: number) => void;
  handleRenameTabComplete: (renameValue: string, tabId: number) => void;
  reOrderTabList: (moveAction: string, moveItemInd: number) => void;
  inPopup?: boolean;
  tabAreaBackgroundColor?: string;
  iconColor?: string;
  selectedTabBackgroundColor?: string;
  childRef?: React.RefObject<HTMLDivElement>;
}

const TabList: React.FC<TabListProps> = ({
  tabList,
  tabState,
  tabTileProps,
  selectedTab,
  backgroundColor,
  handleClose,
  handleSelectTab,
  toggleTabHidden,
  handleRemoveTab,
  handleRenameTabBegin,
  handleRenameTabComplete,
  reOrderTabList,
  tabAreaBackgroundColor,
  iconColor,
  selectedTabBackgroundColor,
  inPopup = false,
  childRef,
}) => {
  // added to count visible tabs
  const visibleTabsCount = tabList.reduce((acc, tabId) => {
    const tab = tabState.tabs[tabId];
    // If tab exists and is NOT hidden, increment count
    if (tab && !tab.hidden) {
      return acc + 1;
    }
    return acc;
  }, 0);

  // FILTER BASED ON HIDDEN + MODE
  const filteredTabs = tabList.filter((tabId) => {
    const tabObj = tabState.tabs[tabId];

    // Tab missing? skip
    if (!tabObj) return false;

    // In EDIT mode → show all tabs
    if (tabTileProps.dashMode === 'Edit') return true;

    // In PRESENT or TV DISPLAY → hide hidden tabs
    return tabObj.hidden !== true;
  });

  const renderTabs = filteredTabs.map((tab: number, tabIndex) => {
    const currentObj: IndTabs = tabState.tabs[tab];

    if (!currentObj) return null;

    const otherTabNames = tabList
      .filter((id) => id !== tab)
      .map((id) => tabState.tabs[id]?.tabName?.toLowerCase())
      .filter(Boolean) as string[];

    const tabComponent = (
      <IndividualTab
        key={currentObj.tabId}
        tabIndex={tabIndex}
        totalTabs={tabList?.length}
        visibleTabsCount={visibleTabsCount}
        tabName={currentObj.tabName}
        editingTabId={tabTileProps.editingTabId}
        editing={tabTileProps.editTabName}
        selectedTab={selectedTab || tabTileProps.selectedTabId}
        backgroundColor={backgroundColor}
        hidden={currentObj.hidden}
        toggleTabHidden={toggleTabHidden}
        tabId={currentObj.tabId}
        reOrderTabList={reOrderTabList}
        selectTab={handleSelectTab}
        removeTab={handleRemoveTab}
        renameTabBegin={handleRenameTabBegin}
        renameTabComplete={handleRenameTabComplete}
        tabAreaBackgroundColor={tabAreaBackgroundColor}
        iconColor={iconColor}
        selectedTabBackgroundColor={selectedTabBackgroundColor}
        showDash={tabTileProps.showDash}
        dashMode={tabTileProps.dashMode}
        otherTabNames={otherTabNames}
      />
    );

    return inPopup ? (
      <MenuItem
        key={currentObj.tabId}
        // onClick={handleClose}
        style={{
          width: '100%',
          margin: '0px',
          padding: '0px',
          height: '35px',
          minHeight: '35px',
          backgroundColor: 'transparent',
        }}
      >
        {React.cloneElement(tabComponent, {
          popupClass: 'popupTab',
          inPopup: true,
        })}
      </MenuItem>
    ) : (
      tabComponent
    );
  });

  return (
    <div
      ref={childRef}
      style={{
        display: `${inPopup ? 'block' : 'flex'}`,
        width: 'content',
      }}
    >
      {renderTabs}
    </div>
  );
};

export default TabList;
